import { LoginForm } from "@/components/login-form"

export default function LoginPage({ apiBaseUrl }: { apiBaseUrl: string }) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-[url('/_DSC9011-2.jpg')] bg-cover bg-center p-6 md:p-9">
      <div className="w-full max-w-sm md:max-w-3xl">
        <LoginForm apiBaseUrl={apiBaseUrl} />
      </div>
    </div>
  )
}

